import { z } from 'zod';

import { DEAL_NOTE_MAX_LENGTH } from '@crm/entities/deal';
import { DateHelpers } from '@crm/shared/lib';

import { POSTPONED_NOTE_FIELD_NAME, POSTPONED_UNTIL_FIELD_NAME } from './consts';

import type { TPostponeDealsPayload } from '@crm/entities/deal';
import type { TFunction } from 'i18next';

export const createPostponeDealSchema = (t: TFunction) =>
    z.object({
        [POSTPONED_UNTIL_FIELD_NAME]: z
            .string()
            .trim()
            .min(1, t('crm.postponeDeal.validation.required'))
            .refine(
                (value) => DateHelpers.parseDisplayDate(value) !== undefined,
                t('crm.common.validation.invalidDate')
            )
            .transform((value) => DateHelpers.formatApiDate(DateHelpers.parseDisplayDate(value)!)),
        [POSTPONED_NOTE_FIELD_NAME]: z
            .string()
            .trim()
            .max(
                DEAL_NOTE_MAX_LENGTH,
                t('crm.postponeDeal.validation.noteMaxLength', {
                    max: DEAL_NOTE_MAX_LENGTH,
                })
            ),
    });

export type TPostponeDealFormInput = z.input<ReturnType<typeof createPostponeDealSchema>>;
export type TPostponeDealFormState = TPostponeDealsPayload;

export const defaultFormValues: TPostponeDealFormInput = {
    [POSTPONED_UNTIL_FIELD_NAME]: '',
    [POSTPONED_NOTE_FIELD_NAME]: '',
};
